module.exports = __webpack_public_path__ + "static/img/Report3DImg2.db751878.png";